$ = j223;
$(function() {
  $(window).on("scroll", function() {
    if($(window).scrollTop() > 20) {
       $(".site-header").addClass("tinted-background");
    } else {
       $(".site-header").removeClass("tinted-background");
    }
  });
  
  $(".blog__slideshow").flickity({
  	// options
    contain: true,
    lazyLoad: true,
    pageDots: false,
    arrowShape: 'M81,49.49,40.31,49,41,63.69l-.41.45L1,32.83V32L39.82.86l.62.34.4,13.65,39.45-2.57Z'
  });
});